import React from "react";
import { useDispatch } from "react-redux";
import KendoMergeTicketGrid from "./KendoMergeTicketGrid";
import { setMergeTicketCustomerId } from "../../../store/reducers/TicketTaskFilter";

const MergeTicketGrid = (props) => {

  const dispatch = useDispatch();
  const TriggerPopup = () => {
    dispatch(setMergeTicketCustomerId(''));
    props.parentCallback(false);
  };

  const AlterMergePopup = () => {
    props.parentCallback(false);
  };

  return (
    <div>
      <div className="overlay">
        <div className="popup change-password">
          <div className="popup__header">
            <h3>Merge Tickets</h3>
            <span
              className="close"
              role="button"
              onClick={() => TriggerPopup(true)}
            >
              ×
            </span>
          </div>

          <div className="content">
            <div className="popup__body12">
              <div className="row">
                <div className="col-md-12 col-sm-12" id="gridWidth">
                  <KendoMergeTicketGrid parentCallback={AlterMergePopup} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MergeTicketGrid;
